<template>
<!-- 应付数据 -->
  <div class="deal-with">
    <HeadControl ref="HeadControl" :titleName="'应付数据'" :showorg="false" @changePicker="changePicker" @changDate="changDate"></HeadControl>
    <div class="inner-top">
      <div class="item" v-for="(item, index) in summaryList" :key="index">
        <div class="l-box">
          <div class="l-t">{{item.itemName}}</div>
            <div class="l-a">{{aFormat(item.amount)}}<span>元</span></div>
            <div class="l-t">{{item.count}}<span>{{item.itemName == '众惠应付款' || item.itemName == '回款应开票' ? '个项目' : '笔'}}</span>
            </div>
          </div>
          <div class="r-box">
            <img :src="item.itemIcon" />
          </div>
      </div>
    </div>
    <div class="inner-bottom">
      <div class="left">
        <div class="left-t" v-for="(item, index) in invoiceTotal" :key="index">
          <div class="icon">
            <img :src="item.itemIcon" />
          </div>
          <div class="desc">
            <div class="a-title">{{item.itemName}}</div>
            <div class="amount">{{aFormat(item.amount)}}<span>元</span></div>
            <div class="a-title">{{item.count}}笔</div>
          </div>
        </div>
      </div>
      <div class="right" style="">
        <div ref="invoiceTotal" style="height: 100%"></div>
      </div>
    </div>
    <div class="inner-bottom">
      <div class="left">
        <div class="left-t" v-for="(item, index) in payableTotal" :key="index">
          <div class="icon">
            <img :src="item.itemIcon" />
          </div>
          <div class="desc">
            <div class="a-title">{{item.itemName}}</div>
            <div class="amount">{{aFormat(item.amount)}}<span>元</span></div>
            <div class="a-title">{{item.count}}笔</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div ref="payableTotal" style="width: 100%; height: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Urls from '@/helper/Urls';
import HeadControl from "@/components/HeadControl";
import {EchartsformatDate, amountFormat, floatDiv, checkDay, subStringNum, floatWidth} from '@/helper/VueHelper.js'
export default {
  components: {
    HeadControl,
  },
  data() {
    return {
      dataRange: [],
      summaryList: {},
      invoiceList: {},
      invoiceTotal: {},
      payableList: {},
      payableTotal: {},
      isH5: false,
      screenWidth: document.body.clientWidth
    }
  },
  methods: {
    init() {
      this.$refs.HeadControl.getDatas('month');
    },
    changePicker(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getInvoiceData();
      this.getPayableData();
    },
    changDate(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getInvoiceData();
      this.getPayableData();
    },
    aFormat(amount) {
      return amountFormat(amount);
    },
    // 汇总数据
    getSummaryData() {
      let url = Urls.financeReturnedSummaryReportItemData;
      let params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.summaryList = server_data.data.series;
      });
    },
    // 代付金额&实付金额走势
    initChart() {
      this.myChart = this.$echarts.init(this.$refs.invoiceTotal, {width: 'auto'});
      let {legend, series, xAxis} = this.invoiceList;
      let maxAmount = Math.max(...series[0].data, ...series[1].data);
      
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "代付金额&实付金额走势",
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: floatWidth(maxAmount, 9) + 25,
          right: this.isH5 ? "20" : '40',
          top: "100",
          bottom: this.isH5 ? 30 : 50,
          // containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function (params) {
            let h = `<div style="padding: 5px 10px; font-size: 12px">`;
            params.forEach(item => {
              if (item.seriesIndex == 0) {
                h += `<div >${EchartsformatDate(item.axisValue)}</div>
                        <div>${item.marker}${item.seriesName}：${amountFormat(item.value)}元</div>
                      `
              } else {
                if (params.length == 1) {
                  h += `<div >${EchartsformatDate(item.axisValue)}</div>`
                }
                h += `<div>${item.marker}${item.seriesName}：${amountFormat(item.value)}元</div></div>`
              }
            });

            return h;
          },
          axisPointer: {
              lineStyle: {
                  color: '#DDDDDD',
                  type:'solid'
              },
          },
        },
        legend: {
          show: true,
          x: this.isH5 ? 250 : 300,
          y: this.isH5 ? 13 : 25,
          icon: "circle",
          itemGap: this.isH5 ? 10 : 25,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#646464",
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
          data: legend,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: 0,
            axisLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? true : false,
              lineStyle: {
                color: '#dddddd'
              }
            },
            axisLabel: {
              color: "#666666",
              interval: this.screenWidth <= 1366 || checkDay(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),
              // padding: [8, 0, 0, 0],
              show: this.isH5 ? false : true,
              margin: 15
            },
            splitLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
              lineStyle: {
                color: "#dddddd",
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
            data: xAxis.data,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "金额(万)",
            min: 0,
            max: maxAmount,
            splitNumber: 5,
            interval: maxAmount < 0.05 * 10000 ? maxAmount : maxAmount / 5,
            show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
            splitLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
              lineStyle: {
                color: "#dddddd",
                type: "solid",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              // padding:[2,2,2,2],
              textStyle: {
                color: "#666666",
              },
              formatter: (params) => {
                let res = floatDiv(params, 10000);
                res.toFixed(2);
                return Math.max(...series[0].data, ...series[1].data) == 0 ? params : (params == 0 ? 0 : subStringNum(res, 2));
              }
            },
            axisTick: {
              show: false,
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 0, 0, -20],
              color: "#666666",
            },
          },
        ],
        series: [
          {
            name: series[0].name,
            type: "line",
            smooth: true,
            symbolSize: 2,
            showSymbol: false,
            itemStyle: {
              normal: {
                opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                color: "#5ebbff",
                lineStyle: {
                  color: "#5ebbff", 
                  width: 2,
                  opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                },
              },
            },
            areaStyle: {
              normal: {
                color: "#e6f5ff",
              },
            },
            data: series[0].data,
          },
          {
            name: series[1].name,
            type: "line",
            smooth: true,
            stack: "总量",
            symbolSize: 2,
            showSymbol: false,
            itemStyle: {
              normal: {
                opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                color: "#61D9AC",
                lineStyle: {
                  color: "#61D9AC", 
                  width: 2,
                  opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                },
              },
            },
            areaStyle: {
              normal: {
                color: "#61D9AC",
                opacity: 0.15
              },
            },
            data: series[1].data,
          },
        ],
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.myChart.resize({width: this.screenWidth - 24}) : this.myChart.resize();
      });
      this.isH5 ? this.myChart.resize({width: this.screenWidth - 24}) : this.myChart.resize();
    },
    getInvoiceData() {
      let url = Urls.payableReturnedReportItemData;
      let params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.invoiceList = server_data.data;
        this.invoiceTotal = server_data.data.amountAndCount;
        this.initChart();
      });
    },
    // 劳务金额&实付金额走势
    initChart2() {
      this.myChart2 = this.$echarts.init(this.$refs.payableTotal, {width: 'auto'});
      let {legend, series, xAxis} = this.payableList;
      // let maxAmount = Math.ceil(Math.max(...series[0].data, ...series[1].data) / 10) * 10;
      let maxAmount = Math.max(...series[0].data, ...series[1].data);
      
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "劳务金额&实付金额走势",
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: floatWidth(maxAmount, 9) + 25,
          right: this.isH5 ? "20" : '40',
          top: "100",
          bottom: this.isH5 ? 30 : 50,
          // containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function (params) {
            let h = `<div style="padding: 5px 10px; font-size: 12px">`;
            params.forEach(item => {
              if (item.seriesIndex == 0) {
                h += `<div >${EchartsformatDate(item.axisValue)}</div>
                        <div><div>${item.marker}${item.seriesName}：${amountFormat(item.value)}元</div>
                      `
              } else {
                if (params.length == 1) {
                  h += `<div >${EchartsformatDate(item.axisValue)}</div>`
                }
                h += `<div>${item.marker}${item.seriesName}：${amountFormat(item.value)}元</div></div>`
              }
            });

            return h;
          },
          axisPointer: {
              lineStyle: {
                  color: '#DDDDDD',
                  type:'solid'
              },
          },
        },
        legend: {
          show: true,
          x: this.isH5 ? 250 : 300,
          y: this.isH5 ? 13 : 25,
          icon: "circle",
          itemGap: this.isH5 ? 10 : 25,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#646464",
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
          data: legend,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: 0,
            axisLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? true : false,
              lineStyle: {
                color: '#dddddd'
              }
            },
            axisLabel: {
              color: "#666666",
              interval: this.screenWidth <= 1366 || checkDay(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),
              // padding: [8, 0, 0, 0],
              show: this.isH5 ? false : true,
              margin: 15
            },
            splitLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
              lineStyle: {
                color: "#dddddd",
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
            data: xAxis.data,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "金额(万)",
            min: 0,
            max: maxAmount,
            splitNumber: 5,
            interval: maxAmount < 0.05 * 10000 ? maxAmount : maxAmount / 5,
            show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
            splitLine: {
              show: Math.max(...series[0].data, ...series[1].data) == 0 ? false : true,
              lineStyle: {
                color: "#dddddd",
                type: "solid",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              // padding:[2,2,2,2],
              textStyle: {
                color: "#666666",
              },
              formatter: (params) => {
                let res = floatDiv(params, 10000);
                res.toFixed(2);
                return Math.max(...series[0].data, ...series[1].data) == 0 ? params : (params == 0 ? 0 : subStringNum(res, 2));
              }
            },
            axisTick: {
              show: false,
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 0, 0, -20],
              color: "#666666",
            },
          },
        ],
        series: [
          {
            name: series[0].name,
            type: "line",
            smooth: true,
            symbolSize: 2,
            showSymbol: false,
            itemStyle: {
              normal: {
                opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                color: "#5ebbff",
                lineStyle: {
                  color: "#5ebbff", 
                  width: 2,
                  opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                },
              },
            },
            // areaStyle: {
            //   normal: {
            //     color: "#e6f5ff",
            //   },
            // },
            data: series[0].data,
          },
          {
            name: series[1].name,
            type: "line",
            smooth: true,
            stack: "总量",
            symbolSize: 2,
            showSymbol: false,
            itemStyle: {
              normal: {
                opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                color: "#72d8c0",
                lineStyle: {
                  color: "#72d8c0", 
                  width: 2,
                  opacity: Math.max(...series[0].data, ...series[1].data) == 0 ? 0 : 1,
                },
              },
            },
            // areaStyle: {
            //   normal: {
            //     color: "#cbeef1",
            //   },
            // },
            data: series[1].data,
          },
        ],
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.myChart2.resize({width: this.screenWidth - 24}) : this.myChart2.resize();
      });
      this.isH5 ? this.myChart2.resize({width: this.screenWidth - 24}) : this.myChart2.resize();
    },
    getPayableData() {
      let url = Urls.laborReturnedReportItemData;
      let params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.payableList = server_data.data;
        this.payableTotal = server_data.data.amountAndCount;
        this.initChart2();
      });
    },
  },
  mounted() {
    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth; //实时宽度
        this.screenWidth = window.screenWidth;
      })();
    }; 
  },
}
</script>

<style lang="scss">
.deal-with {
  margin-top: 0.3rem;
  .inner-top {
    display: flex;
    justify-content: space-between;
    .item {
      width: calc(25% - 0.24rem);
      padding: 0.24rem;
      // margin-right: 0.24rem;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:first-child {
        width: calc(25% - 0.12rem);
      }
      &:last-child {
        // margin-right: 0;
        width: calc(25% - 0.12rem);
      }
      .l-box {
        .l-t {
          font-size: 0.14rem;
          color: #999;
        }
        .l-a {
          font-size: 0.26rem;
          color: #333;
          padding: 0.05rem 0;
          span {
            font-size: 0.14rem;
          }
        }
      }
      .r-box {
        width: 0.55rem;
        height: 0.55rem;
        img {
          width: 0.55rem;
          height: 0.55rem;
        }
      }
    }
  }
  .inner-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 0.24rem;
    .left {
      width: calc(25% - 0.12rem);
      padding: 0.24rem;
      box-sizing: border-box;
      // margin-right: 0.24rem;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      min-height: 3.59rem;
      .left-t {
        display: flex;
        // justify-content: center;
        align-items: center;
        padding: 0.35rem 0 0.35rem 0.3rem;
        border-bottom: 1px solid #eee;
        .icon {
          width: 0.55rem;
          height: 0.55rem;
          margin-right: 0.3rem;
          img {
            width: 0.55rem;
            height: 0.55rem;
          }
        }
        .desc {
          .a-title {
            font-size: 0.14rem;
            color: #999;
            margin-bottom: 0.05rem;
          }
          .amount {
            font-size: 0.18rem;
            line-height: 0.36rem;
            color: #333;
            span {
              font-size: 0.14rem;
            }
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .right {
      width: calc(75% - 0.12rem);
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
    }
  }
}
@media screen and (max-width: 1550px) {
  .deal-with .inner-top .item, .deal-with .inner-bottom .left {
    padding: 0.2rem;
  }
  .deal-with .inner-top .item .l-box .l-a, .deal-with .inner-bottom .left .left-t .desc .amount {
    font-size: 0.16rem;
  }
  .deal-with .inner-bottom .left .left-t {
    padding: 0.35rem 0 0.35rem 0;
  }
  .deal-with .inner-bottom .left .left-t .icon {
    margin-right: 0.15rem;
  }
}
@media screen and (max-width: 768px) {
  .deal-with {
    margin-top: 0;
    .inner-top {
      flex-direction: column;
      align-items: center;
      margin-top: -0.05rem;
      .item {
        width: calc(100% - 0.24rem);
        margin-bottom: 0.12rem;
        &:first-child,  &:last-child {
          width: calc(100% - 0.24rem);
        }
      }
    }
    .inner-bottom {
      margin-top: 0;
      flex-direction: column;
      align-items: center;
      .left {
        width: calc(100% - 0.24rem);
        min-height: 0;
        padding: 0 0.2rem;
        .left-t {
            padding: 0.15rem 0 0.15rem 0;
        }
      }
      .right {
        width: calc(100% - 0.24rem);
        height: 3.5rem;
        margin: 0.12rem 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// dealWithData.vue?173f438b